import Stack from '@mui/material/Stack';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';

type Props = {
  children: React.ReactNode;
};

export const ActionRow = ({ children }: Props) => {
  const { isMobile } = useBreakpoint();
  return (
    <Stack
      sx={{
        '& > *': {
          overflow: 'hidden',
        },
        alignItems: 'center',
        flexDirection: 'row',
        gap: 1.5,
        justifyContent: isMobile ? 'space-between' : 'flex-end',
        width: '100%',
      }}
    >
      {children}
    </Stack>
  );
};
